const createDefaultConfiguration = () => {
    return {
        title: 'Image Widget',
    }
}

export default createDefaultConfiguration

export const ImageWidgetConfigurationInitializerForWidgetExplorer = createDefaultConfiguration
